import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from './ui/Toasts';
import { Skeleton } from './ui/States';
import { useModelsStore } from '../store/modelsStore';
import { useAuth } from '../auth/AuthContext';
import '../studio.css';

export function Layout() {
  const loadModels = useModelsStore((s) => s.load);
  const { user } = useAuth();
  useEffect(() => {
    // A store mantém o estado de carga; falhas não devem gerar rejeições sem tratamento.
    void loadModels().catch(() => {});
  }, [loadModels, user?.guid]);

  return (
    <div className="studio-shell flex h-screen overflow-hidden bg-cloud">
      <a className="studio-skip-link" href="#studio-main">Ir para o conteúdo</a>
      <Sidebar />
      <main id="studio-main" tabIndex={-1} className="studio-main flex min-w-0 flex-1 flex-col overflow-hidden">
        <Suspense fallback={
          <div className="studio-page-body flex-1" role="status" aria-live="polite">
            <span className="sr-only">Carregando tela…</span>
            <Skeleton className="h-8 w-48" />
            <Skeleton className="mt-6 h-64 w-full" />
          </div>
        }>
          <Outlet />
        </Suspense>
      </main>
      <Toaster />
    </div>
  );
}
